export interface HotTopic {
  rank: number;
  tag: string;
  title: string;
  heat: number;
  spread: number; // 距热搜登顶百分比
  delta: string;
  state: "引爆" | "发酵" | "登顶" | "回落";
}

export interface SpreadNode {
  time: string;
  label: string;
  title: string;
  desc: string;
  icon: string;
}

export interface FlashItem {
  time: string;
  tag: string;
  text: string;
  tone: "hot" | "rise" | "down" | "normal";
}

export interface StatItem {
  num: string;
  unit: string;
  label: string;
}

export const hotBoard: HotTopic[] = [
  { rank: 1, tag: "文娱", title: "某顶流综艺收工后深夜同框，粉丝连夜控评失败", heat: 98, spread: 96, delta: "+312%", state: "登顶" },
  { rank: 2, tag: "商业", title: "头部主播带货翻车售后被扒，退款通道一度关闭", heat: 93, spread: 88, delta: "+264%", state: "引爆" },
  { rank: 3, tag: "科技", title: "新机发布会PPT疑似抄袭海外样张，对比图刷屏", heat: 87, spread: 76, delta: "+198%", state: "发酵" },
  { rank: 4, tag: "民生", title: "某连锁餐饮后厨视频流出，门店连夜发声明删帖", heat: 81, spread: 69, delta: "+157%", state: "引爆" },
  { rank: 5, tag: "体育", title: "国家队名单争议引众怒，主教练旧采访被逐句回锅", heat: 72, spread: 58, delta: "+121%", state: "回落" },
];

export const spreadNodes: SpreadNode[] = [
  { time: "T+0.5h", label: "原点引爆", title: "一段源物料落地", desc: "首发截图或视频出现在小号与匿名社区，配一句钩子文案，种子用户开始复制转发。", icon: "ri-flashlight-fill" },
  { time: "T+2h", label: "病毒传播", title: "跨平台复读机被触发", desc: "营销号齐步跟进，同一素材在不同平台被套上不同文案二次加工，播放与转评进入指数上探。", icon: "ri-virus-line" },
  { time: "T+6h", label: "评论区沦陷", title: "控评阵线全面告急", desc: "前排热评开始出现反噬与反转，粉丝刷屏被中立路人淹没，评论区从站队走向摊牌。", icon: "ri-chat-3-line" },
  { time: "T+12h", label: "热搜登顶", title: "主榜高位被锁定", desc: "全网检索与讨论量冲到阈值，话题坐上主榜第一梯队，媒体官号开始跟进定性式报道。", icon: "ri-fire-fill" },
  { time: "T+24h", label: "转发刷屏", title: "二创与表情包接力", desc: "衍生梗与表情包反哺热度，转发刷屏从资讯场景蔓延到段子、游戏与泛娱乐圈层。", icon: "ri-arrow-up-double-line" },
];

export const flashFeed: FlashItem[] = [
  { time: "14:27", tag: "登顶", text: "「某顶流深夜同框」话题登顶热搜主榜，榜首位置已保持约 40 分钟。", tone: "hot" },
  { time: "13:58", tag: "扩散", text: "该素材 30 分钟内在短视频平台出现第二波二创搬运，覆盖播放量突破八位数。", tone: "rise" },
  { time: "13:21", tag: "反转", text: "原视频评论区疑似出现后期修音控评水军，账号注册时间集中，疑似统一行动。", tone: "normal" },
  { time: "12:44", tag: "新增", text: "某官媒旗下账号发出「已关注到网络热议」评论，被视为事件进入公共视野的信号。", tone: "rise" },
  { time: "12:10", tag: "热度", text: "话题页讨论量突破 60 万，同框相关衍生关键词开始自动补全。", tone: "normal" },
  { time: "11:36", tag: "回落", text: "早间登顶的另一话题热度自然回落，为新话题让出主榜高位，曲线呈典型倒 V。", tone: "down" },
];

export const statBoard: StatItem[] = [
  { num: "4.2", unit: "亿", label: "全网相关阅读增量" },
  { num: "873", unit: "万", label: "讨论与转评峰值" },
  { num: "12.6", unit: "小时", label: "平均引爆到登顶时长" },
  { num: "31", unit: "条", label: "近 7 日上榜引爆路径" },
];